export default __webpack_public_path__ + "static/media/hand-with-credit-card.abadfac0.svg";